import * as angular from "angular";

export class NationBuilderService {
    private apiRoot: string;
    private $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.apiRoot = __env.apiUrl() + "/import/nationbuilder";
    }

    nations(): Promise<object> {
        return this.$http.get(this.apiRoot + "/nations");
    }

    lists(data: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/lists/" + data.item);
    }

    imports(data: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/imports/" + data.item);
    }

    contactStatuses(): Promise<object> {
        return this.$http.get(this.apiRoot + "/contact_statuses");
    }

    createNation(data: any): Promise<object> {
        return this.$http.post(this.apiRoot, data);
    }

    editNation(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/" + data.nbnid, data);
    }

    import(item: string | number, data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/importlist/" + item, data);
    }

    deleteNBImport(data: any): Promise<object> {
        return this.$http.post(
            this.apiRoot + "/deletenbimport/" + data.id,
            data
        );
    }

    update(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/update/" + data.nbnid, data);
    }

    delete(data: any): Promise<object> {
        return this.$http.delete(this.apiRoot + "/" + data.nbnid, data);
    }

    cancelImport(data: any): Promise<object> {
        return this.$http.post(
            this.apiRoot + "/importcancel/" + data.nbimportid,
            data
        );
    }
}

angular
    .module("vcServices")
    .service("NationBuilderService", NationBuilderService);
